import api from './api'
import { toast } from 'react-toastify'

export function favoriteAtivo(farmaciaId, usuarioId, ativoId) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      await api.post(`farmacias/${farmaciaId}/usuarios/${usuarioId}/ativos/${ativoId}/favorite`, {}, {
        headers: { authorization: `Bearer ${token}` }
      });

      return resolve();
    } catch (e) {
      toast.error("Falha ao adicionar ativo aos favoritos");
      return reject(e);
    }
  })
}

export function unfavoriteAtivo(farmaciaId, usuarioId, ativoId) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      await api.delete(`farmacias/${farmaciaId}/usuarios/${usuarioId}/ativos/${ativoId}/favorite`, {
        headers: { authorization: `Bearer ${token}` }
      });

      return resolve();
    } catch (e) {
      toast.error("Falha ao remover ativo dos favoritos");
      return reject(e);
    }
  })
}

export function findFavoriteAtivos(farmaciaId, usuarioId, page = 1, itemsPerPage = 15, ref = '') {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      const response = await api.get(`farmacias/${farmaciaId}/usuarios/${usuarioId}/ativos/favorites`, {
        headers: { authorization: `Bearer ${token}` },
        params: { ref, page, itemsPerPage }
      });

      return resolve(response.data);
    } catch (e) {
      return reject(e);
    }
  })
}

export function findAllFavoriteAtivos(farmaciaId, usuarioId) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      const response = await api.get(`farmacias/${farmaciaId}/usuarios/${usuarioId}/ativos/favorites/all`, {
        headers: { authorization: `bearer ${token}` }
      });

      return resolve(response.data.data);
    } catch (e) {
      return reject(e);
    }
  })
}
